import React, { useState } from "react";
import findBlack from "./assets/zoom-question-black.svg";
import findWhite from "./assets/zoom-question-white.svg";
const Faq = () => {
  const [id, setId] = useState(null);
  const data = [
    {
      title: "What is the R34P DAO?",
    },
    {
      title: "How can I participate?",
    },
    {
      title: "How long will the auction last?",
    },
    {
      title: "Can I resell my NFT after winning it in an auction?",
    },
    {
      title: "Are there any fees associated with the auction?",
    },
  ];

  const handleOpenOrClose = (i) => {
    if (i === id) {
      setId(null);
    } else {
      setId(i);
    }
  };
  const SingleRow = ({ index, title }) => {
    return (
      <div
        onClick={() => handleOpenOrClose(index)}
        className=" single-question  cursor-pointer rounded-[20px] py-[13px]  pl-[11px] pr-[14px]  "
      >
        <div className="flex items-center gap-[10px]">
          <div>
            <img className="find-white  opacity-100" src={findWhite} alt="" />
            <img src={findBlack} className="find-black  opacity-0" alt="" />
          </div>
          <p className="xl:text-res-xs grow text-left text-xxs font-bold">
            {title}
          </p>
          <div className="plus-icon-wrap text-res-ls font-bold">
            <span>+</span>
          </div>
        </div>
        <div
          className={`single-question-warp ${index === id ? "open pt-2" : ""}`}
        >
          <p className={`px-2  pb-2 text-left font-medium text-white`}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi
            assumenda dolorum nostrum incidunt oluptate sit iure? Dignissimos
            molestias minus fugit nemo in necessitatibus a eligendi, sapiente
            nam amet maxime quisquam.
          </p>
        </div>
      </div>
    );
  };
  return (
    <div className="container  ">
      <div className="mx-auto max-w-[505px]">
        <div className="text-center ">
          <h2 className="text-res-lg mb-[8px] font-black">
            FAQ<span>s</span>
          </h2>
          <p className="text-res-xs leading-[30px] font-semibold ">
            Frequently Asked Questions about the R34P DAO and Membership
          </p>
          <div className="mt-[26px]">
            {data.map((single, i) => (
              <SingleRow key={i} index={i} {...single}></SingleRow>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
